import React from 'react';
import SelectButtons, { SelectButtonProps } from '../components/SelectButtons';

type Props = Omit<SelectButtonProps, 'fieldTitle'>;

const SelectExpertise = ({
  setSelectedItems,
  selectedItems,
  enumArray,
}: Props) => {
  return (
    <SelectButtons
      fieldTitle="Areas of Expertise"
      setSelectedItems={setSelectedItems}
      selectedItems={selectedItems}
      enumArray={enumArray}
    />
  );
};

export default SelectExpertise;
